import * as Roles from '@/store/roles';
import { namespacedActions } from './actionTypes';

const permissions = {
  [namespacedActions.createCompanyFiles]: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
  [namespacedActions.updateCompanyFiles]: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
  [namespacedActions.addProjectFile]: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
  [namespacedActions.deleteProjectFile]: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
  [namespacedActions.changeProjectFileStatus]: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
  [namespacedActions.changeCodeOfConductStatus]: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
  [namespacedActions.uploadProjectFile]: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
  [namespacedActions.deleteLegacyFiles]: [
    Roles.Admin,
    Roles.ProjectLeader,
    Roles.Trial,
    Roles.SiteManager,
    Roles.SiteAssistant,
  ],
  [namespacedActions.syncCompanyFilesList]: [Roles.Any],
  [namespacedActions.syncCompanyFiles]: [Roles.Any],
};

export default permissions;



// WEBPACK FOOTER //
// ./src/store/companyFiles/permissions.js